// extracted by mini-css-extract-plugin
module.exports = {"office__city":"Office_office__city__539sF","office__location":"Office_office__location__3G_c5","office__address":"Office_office__address__26fFl"};